import React from 'react';

function ProductTabs({ activeTab, onTabChange, phoneEnabled = false, tshirtEnabled = false }) {
  return (
    <div className="product-tabs">
      {phoneEnabled && (
        <button
          className={`tab-btn ${activeTab === 'phone' ? 'active' : ''}`}
          onClick={() => onTabChange('phone')}
        >
          📱 Phone Case
        </button>
      )}
      {tshirtEnabled && (
        <button
          className={`tab-btn ${activeTab === 'tshirt' ? 'active' : ''}`}
          onClick={() => onTabChange('tshirt')}
        >
          👕 T-Shirt
        </button>
      )}
      <button
        className={`tab-btn ${activeTab === 'real' ? 'active' : ''}`}
        onClick={() => onTabChange('real')}
      >
        📸 Real Products
      </button>
    </div>
  );
}

export default ProductTabs;
